import React, {useEffect} from 'react';
import {MapContainer, Marker, Popup, TileLayer, useMap} from 'react-leaflet';
import L from "leaflet";
import * as ReactDOMServer from "react-dom/server";
import {ReactComponent as PinSVG} from "../../../images/icons/pin.svg";

import 'leaflet/dist/leaflet.css';
import {useTranslation} from "react-i18next";

interface MapProps {
    center: [number, number];
    zoom: number;
    useResizer?: boolean;
}

const ResizeMap = () => {
    const map = useMap();

    useEffect(() => {
        const container = map.getContainer();

        const observer = new ResizeObserver(() => {
            map.invalidateSize();
            map.setView(map.getCenter());
        });

        observer.observe(container);

        return () => {
            observer.disconnect();
        };
    }, [map]);

    return null;
}

const Map: React.FC<MapProps> = (props: MapProps) => {
    const {t} = useTranslation();
    const icon = L.divIcon({
        className: "",
        html: ReactDOMServer.renderToString(
            <div aria-label={t('common.word.your_selected_location')} role="img">
                <PinSVG className="icon"/>
            </div>
        ),
        iconSize: [24, 24],
        iconAnchor: [12, 24]
    });

    return (
        <MapContainer
            center={props.center}
            zoom={props.zoom}
            scrollWheelZoom={false}
            dragging={false}
            doubleClickZoom={false}
            zoomControl={false}
            style={{width: '100%'}}
            className="map-container"
        >
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            <Marker position={props.center} icon={icon}>
                <Popup>{t("common.word.your_selected_location")}</Popup>
            </Marker>
            {props.useResizer && <ResizeMap/>}
        </MapContainer>
    );
};

export default Map;
